module.exports = __webpack_public_path__ + "static/media/vc.903f8e2f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/vc.svg
// module id = 282
// module chunks = 0